module.exports = __webpack_public_path__ + "img/contribution1.d5958263.png";